import { AccordionVoidCivilUnion as VoidCivilUnionVM } from 'shell/view-models/accordion-void-civil-union';
import { transformDocumentDigital } from '../shared/transform-document-digital';
import { DissolutionUnionType } from 'shell/models/person/civil-union';

export const transformVoidCivilUnionAnpr05 = (
  values: VoidCivilUnionVM | undefined
): DissolutionUnionType | undefined => {
  const withActPaper =
    values?.paper?.actYear ||
    values?.paper?.actPart ||
    values?.paper?.actSeries ||
    values?.paper?.actNumber ||
    values?.paper?.actVolume ||
    values?.paper?.actDate ||
    values?.paper?.actMunicipality?.description ||
    values?.paper?.actMunicipality?.id ||
    values?.paper?.actMunicipality?.province;

  const withActDigital = Boolean(values?.digital);

  const hasSentenza =
    values?.authority || values?.validityDate || values?.number || values?.courtType;

  const hasEventLocation = values?.eventItaly || values?.eventForeign;

  const returnData: DissolutionUnionType | undefined = values
    ? {
        datiEvento: {
          luogoEvento: hasEventLocation
            ? {
                comune: values?.eventItaly?.municipalityDescription
                  ? {
                      nomeComune: values?.eventItaly?.municipalityDescription || undefined,
                      codiceIstat: values?.eventItaly?.municipalityId || undefined,
                      siglaProvinciaIstat: values?.eventItaly?.province || undefined,
                    }
                  : undefined,
                localita: values?.eventForeign
                  ? {
                      descrizioneStato: values?.eventForeign?.stateDescription || undefined,
                      codiceStato: values?.eventForeign?.stateId || undefined,
                      provinciaContea: values?.eventForeign?.province || undefined,
                    }
                  : undefined,
              }
            : undefined,
          dataEvento: values?.eventDate?.toFormat('yyyy-MM-dd') || undefined,
          attoEventoANPR:
            withActPaper || withActDigital
              ? {
                  atto: withActPaper
                    ? {
                        anno: values?.paper?.actYear || undefined,
                        parte: values?.paper?.actPart || undefined,
                        serie: values?.paper?.actSeries || undefined,
                        numeroAtto: values?.paper?.actNumber || undefined,
                        volume: values?.paper?.actVolume || undefined,
                        dataFormazioneAtto:
                          values?.paper?.actDate?.toFormat('yyyy-MM-dd') || undefined,
                        trascritto: values?.paper?.transcribed ? '1' : undefined,
                        comuneRegistrazione: values?.paper?.actMunicipality
                          ? {
                              nomeComune: values?.paper?.actMunicipality?.description || undefined,
                              codiceIstat: values?.paper?.actMunicipality?.id || undefined,
                              siglaProvinciaIstat:
                                values?.paper?.actMunicipality?.province || undefined,
                            }
                          : undefined,
                      }
                    : undefined,
                  attoANSC: withActDigital
                    ? transformDocumentDigital(values?.digital || undefined)
                    : undefined,
                }
              : undefined,
        },
        sentenza: hasSentenza
          ? {
              autorita: values?.authority || undefined,
              data: values?.sentenceDate?.toFormat('yyyy-MM-dd') || undefined,
              dataValidita: values?.validityDate?.toFormat('yyyy-MM-dd') || undefined,
              numero: values?.number?.toString() || undefined,
              tipoTribunale: values?.courtType || undefined,
            }
          : undefined,
        motivoScioglimento: values?.type ? Number.parseInt(values?.type) : undefined,
      }
    : undefined;

  return returnData;
};
